import React, { useEffect , useState } from "react";
import "./../css/index.css";
const Index = () => {

  return (
    <div className="index">
      <p>پنل ادمین آریانا پارس</p>
    </div>
  );
};

export default Index;
